/**
 * Build timestamp - used to force Vercel rebuilds after schema changes
 * Update this timestamp whenever Supabase schema changes to invalidate build cache
 */
export const BUILD_TIMESTAMP = '2024-12-19T12:00:00Z';

/**
 * ONL Build Stamp - Explicit build identifier for deployment verification
 * Update this whenever deploying a new version to verify which deployment is loaded
 * MUST NOT contain timestamps, Date.now(), new Date(), or randomness
 */
export const ONL_BUILD = "2026.01.05.02";
export const ONL_BUILD_NOTE = "Fix week view crash + stabilisers";